module.exports = __webpack_public_path__ + "img/merchant.813d55de.gif";